import Resource from '@/api/resources/Resource'

class CommonComplementaryService extends Resource {
    async getAllComplementariesByLaboratoryAndCaseId(labId, casId) {
        return this.axios.get(`/common/laboratories/${labId}/cases/${casId}/complementaries`).then(response => response.data)
    }

    async search(params) {
        const response = await this.axios.get('/common/complementaries/search', { params })
        return response.data
    }

    async complementarySectionsSummary(laboratoryId, caseId, complementaryId) {
        return this.axios.get(`/diagnosis/laboratories/${laboratoryId}/cases/${caseId}/complementaries/${complementaryId}/sectionsSummary`).then(response => response.data)
    }
}

export default new CommonComplementaryService()
